import { Injectable } from '@angular/core'
import { AreaApi } from './base'

@Injectable()
export class StaticContentAreaApi extends AreaApi{
  apiPath(resourceId: number, areaId = '') {
    return `static_contents/${resourceId}/areas/${areaId}`
  }
}



// WEBPACK FOOTER //
// ./src/apis/area/static-content.ts